/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const Taxiway: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <G clipPath='url(#clip0_53_262)'>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.3639 16.6809L11.127 13.3587L10.0729 17.3504L11.2204 18.8282L10.935 19.909L8.62528 18.5345L5.95524 18.5939L6.24063 17.5132L7.93385 16.7856L8.98797 12.7938L2.8279 13.1064L3.20536 11.677L9.84876 9.53415L10.9029 5.54238C10.9827 5.24024 11.1529 5.0117 11.4134 4.85675C11.674 4.7018 11.9583 4.665 12.2664 4.74634C12.5744 4.82768 12.8006 4.9993 12.945 5.26119C13.0894 5.52309 13.1217 5.80511 13.0419 6.10725L11.9878 10.099L16.7413 15.2515L16.3639 16.6809Z'
                fill='#E5E5E6'
            />
            <Path
                d='M19.75 8.89435V24H18.25V8.89435C18.25 4.93504 20.61 1.52694 24 0V1.67719C21.4653 3.08502 19.75 5.78937 19.75 8.89435Z'
                fill='#E5E5E6'
            />
            <Path
                d='M1.5 8.89435V24.0001H0V8.89435C0 4.93504 2.35999 1.52694 5.75 0V1.67719C3.2153 3.08502 1.5 5.78937 1.5 8.89435Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_53_262'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
